import { Add } from "@mui/icons-material";

import { idOf } from "@moment/api-collab/differential/Tuple";

import { TextboxAuto } from "~/components/common/inputs/TextboxAuto";
import { cn } from "~/utils/cn";

import { Button } from "../Button";
import { Dialog } from "../Dialog";
import ColumnsPopover from "./ColumnsPopover";
import RecordCard from "./RecordCard";
import { useBaseView } from "./useBaseView";

export function BaseView() {
	const viewHandle = useBaseView();

	return (
		<Dialog
			open={viewHandle.rowDialogOpen}
			onOpenChange={(open) => !open && viewHandle.closeRowDialog()}
		>
			<div className="flex flex-col space-y-2">
				<div className="flex flex-row">
					<TextboxAuto
						className={cn(
							"text-lg font-bold bg-transparent",
							viewHandle.spec?.viewTitle ? "font-bold" : "font-semibold italic"
						)}
						placeholder="Untitled"
						defaultValue={viewHandle.spec?.viewTitle}
						onChange={(e) => {
							viewHandle.updateViewTitle(e.target.value);
						}}
					/>
					<div className="flex flex-row space-x-1 mr-2 ml-auto">
						<ColumnsPopover viewHandle={viewHandle} />
						{/* TODO: Support this. */}
						{/* <Button preset="quaternary" size="md" className="!px-1.5">
							Filter
						</Button>
						<Button preset="quaternary" size="md" className="!px-1.5">
							Sort
						</Button>
						<IconButton
							elevation="flat"
							size="md"
							preset="tertiary"
							borderRadius="default"
							icon={<SearchOutlined />}
							label="Search"
						/> */}
					</div>
					<Button
						preset="primary"
						size="md"
						elevation="flat"
						startIcon={<Add />}
						onClick={viewHandle.appendRow}
					>
						New
					</Button>
				</div>
				{viewHandle.data.length > 0 &&
					viewHandle.data.map((item, index) => {
						const rowId = idOf(item.original);
						return (
							<RecordCard.Trigger
								key={rowId}
								row={item}
								recordIndex={index}
								viewHandle={viewHandle}
							/>
						);
					})}
				<div>
					<Button
						preset="quaternary"
						size="md"
						startIcon={<Add />}
						onClick={viewHandle.appendRow}
					>
						New Card
					</Button>
				</div>
			</div>
			{viewHandle.table && viewHandle.openItemIndex !== undefined && viewHandle.openItem && (
				<RecordCard.Content table={viewHandle.table} viewHandle={viewHandle} />
			)}
		</Dialog>
	);
}
